import styled from 'styled-components';

export const Main = styled.main`
  position: relative;
  min-height: 100vh;
`;
